// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationRewardsPath = 'M49.992 97.2l-46.8-50.9a11.8 11.8 0 01-1.6-13.5l10.6-19.8h75.6l10.7 19.8a12.001 12.001 0 01-1.7 13.5l-46.8 50.9zM7.745 36h20.53L15.553 21.551 7.746 36zm24.59 7L45.46 81.876 9.68 43h22.657zm7.336 0l10.32 30.7L60.654 43H39.672zm28.482 0L54.732 81.65 90.303 43h-22.15zm24.084-7h-19.38L84.46 21.607 92.238 36zm-36.63-16h21.133L66.69 32.6 55.61 20zm-32.08 0h21.157L34.592 32.6 23.528 20zm17.223 16h19.597L50.092 24.4 40.75 36z';
var IllustrationRewards = baseIllustration('IllustrationRewards', {
  getPath: () => IllustrationRewardsPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationRewards;
//# sourceMappingURL=index.js.map